export class Instrument {
  constructor(public family: string, public name: string) {}
}
